import { Box, Button, ContentTemplate, SectionHeader, TitleHeader } from 'web-library';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Theme as AugmentedTheme, useTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import { useMediaQuery } from '@mui/material';
import { MutationStatus } from 'react-query';
import SpecialConsiderationListingTable from './SpecialConsiderationListingTable';
import SelectExamLevelModal from './SelectExamLevelModal';
import { useGetCandidateListing } from '../../../api-refactored/special-consideration/useGetCandidateListing';

const useStyles = makeStyles()((theme) =>
({
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      marginBottom: theme.spacing(3),
    },
  },
  newApplicationButton: {
    height: 'fit-content',
  },
  dataTable: {
    marginBottom: theme.spacing(20),
  },
}));

const SpecialConsiderationListing = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [examLevel, setExamLevel] = useState<string | null>(null);
  const [examSeries, setExamSeries] = useState<string | null>(null);
  const [isError, setIsError] = useState<boolean>(false);
  const [dialogCustomStatus, setDialogCustomStatus] = useState<MutationStatus>('idle');

  const { data: listingData, isFetching, refetch: refetchListing } = useGetCandidateListing({});

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const onDialogClose = () => {
    setOpenModal(false);
    setExamLevel(null);
    setExamSeries(null);
    setIsError(false);
    setDialogCustomStatus('idle');
  };

  return (
    <>
      <TitleHeader title={t('specialConsideration->>Listing.SpecialConsideration')} />
      <ContentTemplate transparent continuous type="full">
        <Box className={classes.headerContainer}>
          <SectionHeader
            title={t('specialConsideration->>Listing.SpecialConsiderationApplications')}
          />
          <Button
            id="button-new-application-sc"
            className={classes.newApplicationButton}
            fullWidth={isMobile}
            onClick={handleOpenModal}
            disabled={!listingData?.canApplication}
          >
            {t('specialConsideration->>Listing.NewApplication')}
          </Button>
        </Box>
        {listingData && (
          <Box className={classes.dataTable}>
            <SpecialConsiderationListingTable
              data={listingData}
              isFetching={isFetching}
              refetch={refetchListing}
            />
          </Box>
        )}
        <SelectExamLevelModal
          modalState={openModal}
          onDialogClose={onDialogClose}
          examLevel={examLevel}
          examSeries={examSeries}
          isError={isError}
          dialogCustomStatus={dialogCustomStatus}
          setExamLevel={setExamLevel}
          setExamSeries={setExamSeries}
          setIsError={setIsError}
          setDialogCustomStatus={setDialogCustomStatus}
        />
      </ContentTemplate>
    </>
  );
};
export default SpecialConsiderationListing;
